import { render, staticRenderFns } from "./JTMSAppWrapper.vue?vue&type=template&id=645aea28&scoped=true&"
import script from "./JTMSAppWrapper.vue?vue&type=script&lang=ts&"
export * from "./JTMSAppWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645aea28",
  null
  
)

export default component.exports